import React, { useState } from 'react';
import './footer.css';
// Importer FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import politiquePDF from '../assets/Politique_de_confidentialite.pdf';
import { 
  faMapMarkerAlt, 
  faEnvelope, 
  faPhone,
  faArrowRight,
  faChevronUp,
  faCheckCircle,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import { 
  faLinkedinIn, 
  faTiktok, 
  faFacebookF, 
  faInstagram, 
 // faYoutube 
} from '@fortawesome/free-brands-svg-icons';

function FOOTER() {
   // VARIABLES D'ÉTAT
  const [email, setEmail] = useState('');
  const [emailsList, setEmailsList] = useState([]); // Liste de tous les emails
  const [isLoading, setIsLoading] = useState(false);
  const [honeypot, setHoneypot] = useState('');

  const [message, setMessage] = useState({ text: '', type: '' });

  console.log('emailsList actuelle:', emailsList);

    // FONCTION POUR LA NEWSLETTER
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    // HONEYPOT 
  if (honeypot !== '') {
    // Bot détecté - simuler un succès pour le tromper
    setEmail('');
    setHoneypot('');
    setMessage({ 
      text: 'Merci pour votre inscription !', 
      type: 'success' 
    });
    return; // Arrête tout de suite
  }

    if (!email || !email.includes('@')) return setMessage({ 
      text: 'Veuillez entrer un email valide', 
      type: 'error' 
    });

    setIsLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const res = await fetch('https://moseraigc.com/api/save_email_newsletter.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email: email,
        honeypot: honeypot // Toujours vide pour les humains
         })
        
      });

      const data = await res.json();

      if (data.success) {
        setEmailsList(prev => [...prev, { email, status: 'saved' }]);
        setEmail('');
        setMessage({ 
        text: 'Merci ! Vous êtes maintenant inscrit à notre newsletter.', 
        type: 'success' 
      });
      } else {
        setMessage({ 
        text: data.message || 'Erreur lors de l\'inscription', 
        type: 'error' 
      });
      }
    } catch (err) {
      console.error('Erreur de connexion:', err);
      setMessage({ 
      text: 'Erreur de connexion au serveur', 
      type: 'error' 
    });
      setEmailsList(prev => [...prev, { email, status: 'pending' }]);
    } finally {
      setIsLoading(false);

      // EFFACER LE MESSAGE APRÈS 5 SECONDES
      setTimeout(() => {
      setMessage({ text: '', type: '' });
    }, 5000);
    }
  };


  // Ajoutez cet useEffect pour gérer la disparition automatique
React.useEffect(() => {
  if (message.text) {
    const timer = setTimeout(() => {
      setMessage({ text: '', type: '' });
    }, 5000); // 5 secondes
    
    return () => clearTimeout(timer);
  }
}, [message.text]);


  // Fonction pour le défilement fluide vers les sections
  const scrollToSection = (sectionId, e) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Section principale du footer */}
        <div className="footer-main">
          <div className="footer-section footer-about">
            <div className="footer-brand">
              <h3 className="company-name">MOSE RAI GC</h3>
              <p className="company-tagline">
                Créateur de solutions numériques innovantes pour transformer votre entreprise.
              </p>
            </div>
            <p className="footer-description">
              Nous accompagnons les entreprises dans leur transformation digitale avec des solutions sur mesure, innovantes et performantes.
            </p>
            <div className="footer-newsletter">
              <h4>Restez informé</h4>
                           
              <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <input 
                  type="email" 
                  placeholder="Votre email professionnel" 
                  className="newsletter-input"
                  value={email}  
                  onChange={(e) => setEmail(e.target.value)}  
                  disabled={isLoading}  // <-- Optionnel
                  required
                />

                <input
                  type="text"
                  name="website" 
                  className="newsletter-honeypot"  
                  value={honeypot}
                  onChange={(e) => setHoneypot(e.target.value)}
                  autoComplete="off"
                  tabIndex="-1"  
    />
                <button 
                  type="submit" 
                  className="newsletter-btn"
                  disabled={isLoading}  // <-- Optionnel
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
              </form>

              {/*BLOC POUR LES MESSAGES */}
                {message.text && (
                <div className={`newsletter-message ${message.type}`}>
                <FontAwesomeIcon 
                icon={message.type === 'success' ? faCheckCircle : faExclamationCircle} 
                style={{ 
                marginRight: '8px',
                color: message.type === 'success' ? '#2f855a' : '#c53030'
              }} 
    />
    {message.text}
  </div>
)}
            </div>
          </div>

          <div className="footer-section footer-links">
            <h4>Navigation</h4>
            <ul className="footer-nav">
              <li>
                <button 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('accueil', e)}
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('services', e)}
                >
                  Services
                </button>
              </li>
              {/*<li>
                <button 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('projets', e)}
                >
                  Projets
                </button>
              </li>*/}
              <li>
                <button 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('apropos', e)}
                >
                  À propos
                </button>
              </li>
              <li>
                <button 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('contact', e)}
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-services">
            <h4>Nos Services</h4>
            <ul className="services-list">
              <li>Développement sur mesure</li>
              <li>Transformation digitale</li>
              <li>Intelligence Artificielle</li>
              <li>Cybersécurité</li>
              <li>Vidéo et animations</li>
              <li>Marketing Digital </li>
            </ul>
          </div>

          <div className="footer-section footer-contact">
            <h4>Contactez-nous</h4>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>
                <div className="contact-details">
                  <p>Carrefour Djenontin</p>
                  <p>Abomey-Calavi, Benin</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="contact-details">
                  <p>contact@moseraigc.com</p>
                  <p>supportclient@moseraigc.com</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faPhone} />
                </div>
                <div className="contact-details">
                  <p>+229 01 62 60 49 43 / +229 01 54 86 34 86</p>
                  <p>Lun - Ven: 8h - 18h</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Séparateur */}
        <div className="footer-divider"></div>

        {/* Section réseaux sociaux et copyright */}
        <div className="footer-bottom">
          <div className="social-section">
            <h5>Suivez notre actualité</h5>
            <div className="social-icons">
              <a 
                href="https://www.linkedin.com/company/mose-rai-gc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a 
                href="https://www.tiktok.com/@moseraiglobalcorp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Twitter"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>
              <a 
                href="https://www.facebook.com/moseraiglobalcorp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a 
                href="https://www.instagram.com/moseraiglobalcorp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              {/*<a 
                href="https://youtube.com/@MoseRaiGC" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="YouTube"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>*/}
            </div>
          </div>

          <div className="copyright-section">
            <p className="copyright">
              &copy; {new Date().getFullYear()} <strong>MOSE RAI GC</strong>. Tous droits réservés.
            </p>
            <div className="legal-links">
              <a href={politiquePDF} 
                 download="Politique_de_confidentialite.pdf"
                className="privacy-link" >Politique de confidentialité</a>

            </div>
          </div>

          <div className="footer-back-to-top">
            <button 
              className="back-to-top-btn"
              onClick={(e) => scrollToSection('accueil', e)}
              aria-label="Retour en haut"
            >
              <FontAwesomeIcon icon={faChevronUp} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FOOTER;